import {
  createReduxHistory,
  routerMiddleware,
} from '@components/Router/history'
import {
  batchSaga,
  corePasteSaga,
  relationsSaga,
} from '@octopus-do/octopus-project-core'
import { configureStore } from '@reduxjs/toolkit'
import { blocksSaga } from '@store/blockSaga'
import { crawlImportSaga } from '@store/crawlImport'
import { messagesSaga } from '@store/messagesSaga'
import { accountSaga } from '@store/reducers/account'
import { aiSaga } from '@store/reducers/ai'
import { apiKeysSaga } from '@store/reducers/apiKeys'
import { apiUsageSaga } from '@store/reducers/apiUsage'
import { artboardSaga } from '@store/reducers/artboard'
import { authSaga } from '@store/reducers/auth'
import { commentReadsSaga } from '@store/reducers/commentReads'
import { commentsSaga } from '@store/reducers/comments'
import { dashboardSaga } from '@store/reducers/dashboard/saga/saga'
import { ga4Saga } from '@store/reducers/ga4'
import { inboxSaga } from '@store/reducers/inbox'
import { limitReachedSaga } from '@store/reducers/limitReached'
import { activityHistorySaga } from '@store/reducers/manager/activityHistory/saga'
import managerSaga from '@store/reducers/manager/managerSaga'
import { historyMiddleware } from '@store/reducers/manager/middleware/history/historyMiddleware'
import { storageSaga } from '@store/reducers/manager/storage/saga'
import { projectSaga } from '@store/reducers/project'
import { rootReducer } from '@store/reducers/rootReducer'
import { seoSaga } from '@store/reducers/seo'
import { threadsSaga } from '@store/reducers/threads'
import { upgradePlanSaga } from '@store/reducers/upgradePlan'
import { socketSaga } from '@store/socketSaga'
import { importXmlSaga } from '@store/xmlImportSaga'
import { commitMiddleware } from '@storeOld/middleware/commit'
import { localStorageMiddleware } from '@storeOld/middleware/localStorage'
import { observer } from '@storeOld/observer'
import createSagaMiddleware from 'redux-saga'
import { all } from 'redux-saga/effects'

import { confirmationSaga } from './confirmation'
import { globalSaga } from './globalSaga'
import { librarySaga } from './librarySaga'
import { locksSaga } from './locksSaga'
import { projectAvatarSaga } from './projectAvatar'
import { subscriptionSaga } from './reducers/subscription'
import { templatesSaga } from './reducers/templates'
import { reportExportSaga } from './reportExport'
import { requestsSaga } from './requestsSaga'
import { safeSagaWrapper } from './safeSagaWrapper'
import { uploadResultSaga } from './uploadResultSaga'

const sagaMiddleware = createSagaMiddleware()

function* rootSaga() {
  yield all([
    corePasteSaga(),
    batchSaga(),
    relationsSaga(),
    managerSaga(),
    activityHistorySaga(),
    requestsSaga(),
    reportExportSaga(),
    uploadResultSaga(),
    threadsSaga(),
    commentReadsSaga(),
    dashboardSaga(),
    blocksSaga(),
    globalSaga(),
    commentsSaga(),
    authSaga(),
    confirmationSaga(), // todo: have general ui saga
    artboardSaga(),
    aiSaga(),
    seoSaga(),
    ga4Saga(),
    projectAvatarSaga(),
    upgradePlanSaga(),
    limitReachedSaga(),
    projectSaga(),
    storageSaga(),
    socketSaga(),
    librarySaga(),
    messagesSaga(),
    importXmlSaga(),
    crawlImportSaga(),
    subscriptionSaga(),
    apiKeysSaga(),
    apiUsageSaga(),
    accountSaga(),
    inboxSaga(),
    locksSaga(),
    templatesSaga(),
  ])
}

const sagas = safeSagaWrapper(rootSaga)

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      historyMiddleware,
      localStorageMiddleware,
      commitMiddleware,
      routerMiddleware,
      sagaMiddleware
    ),
})

observer(store)

sagaMiddleware.run(sagas)

export const history = createReduxHistory(store)

export { store }
